import { render, staticRenderFns } from "./RoleSwitchPanel.vue?vue&type=template&id=4091305c&scoped=true&"
import script from "./RoleSwitchPanel.vue?vue&type=script&lang=js&"
export * from "./RoleSwitchPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoleSwitchPanel.vue?vue&type=style&index=0&id=4091305c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4091305c",
  null
  
)

export default component.exports